export const removeChars = (str: string | undefined): string | undefined => {
  return str?.toLowerCase().replace(/[^a-zA-Z]/g, "")
}
